/**
 * Enhance API
 * Endpoint: POST /api/enhance/single
 * Photoroom AI Relight. Strength picks lighting.mode. A custom prompt is not sent.
 */
import apiClient, { createAuthConfig, isMockApi } from "../client";
import { appendLineageToForm } from "./studio_features";
import { appendAiImage } from "./aiUpload";

const MULTIPART = (token) => ({
  ...createAuthConfig(token),
  timeout: 300000,
  headers: {
    ...createAuthConfig(token).headers,
    "Content-Type": "multipart/form-data",
  },
});

/**
 * Enhance an image with Photoroom exposure correction.
 * @param {string} token - Clerk session token
 * @param {File|null} file - Image file (use null when sending image_url)
 * @param {object} [opts]
 * @param {string} [opts.image_url]
 * @param {string} [opts.strength] - subtle | balanced | strong
 * @param {string} [opts.output_format]
 * @returns {Promise<{success: boolean, output_url?: string, credits_used?: number, remaining_credits?: number, creation_id?: string, message?: string}>}
 */
export async function enhanceSingle(token, file, opts = {}) {
  if (isMockApi) {
    const mockSrc = opts.image_url || (file ? URL.createObjectURL(file) : "");
    return {
      success: true,
      output_url: mockSrc || "",
      credits_used: 1,
      remaining_credits: 99,
    };
  }

  const form = new FormData();
  await appendAiImage(form, file, {
    imageUrl: opts.image_url,
    requiredMessage: "enhanceSingle: provide file or opts.image_url",
  });
  if (opts.strength) form.append("strength", opts.strength);
  if (opts.output_format) form.append("output_format", opts.output_format);
  appendLineageToForm(form, opts.lineage);

  const response = await apiClient.post(
    "/api/enhance/single",
    form,
    MULTIPART(token)
  );
  return response.data;
}

export default {
  enhanceSingle,
};
